import React from 'react';

/**
 * Accounting user information component
 */
export const AccountingUserInfo: React.FC = () => {
  return (
    <div className="bg-purple-50 border border-purple-200 rounded-lg p-6">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
          <span className="text-purple-600 font-semibold text-lg">💰</span>
        </div>
        <div>
          <h3 className="text-lg font-semibold text-purple-900 mb-1">
            حساب محاسبي
          </h3>
          <p className="text-purple-700">
            يمكنك الوصول إلى الوحدات المالية المتاحة لك من القائمة الجانبية مثل التحصيلات والمبيعات والتقارير
          </p>
        </div>
      </div>
    </div>
  );
};
